import styled from "styled-components";

import { Container, Form, Row } from "react-bootstrap";
import { Skeleton } from "@mui/material";

import ButtonComponent from "../../button";

export const StyledContainer = styled(Container)`
  width: 75%;
  @media screen and (max-width: 992px) {
    width: 100%;
  }
  .header-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  h1 {
    font-weight: 500;
    font-size: var(--font-size-lg);
    color: var(--blue-color-dark);
    @media screen and (max-width: 768px) {
      font-size: var(--font-size-base);
    }
    @media screen and (max-width: 576px) {
      font-size: var(--font-size-xs);
    }
  }
  .arrow-right {
    cursor: pointer;
    display: none;
    @media screen and (max-width: 768px) {
      display: inline;
      height: 20px;
      width: 22px;
    }
  }
  .submit-button {
    width: 430px;
    @media screen and (max-width: 768px) {
      width: 90%;
      font-weight: 500;
      font-size: var(--font-size-lg);
    }
  }
  .go-back-button {
    width: 96px;
    height: 38px;
    background-color: transparent;
    border: 1px solid var(--primary-color);
    border-radius: 6px;
    font-weight: 400;
    font-size: var(--font-size-sm);
    color: var(--tertiary-color);
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
  .download-button {
    width: 190px;
    height: 48px;
    background: transparent;
    border: 1px solid var(--tertiary-color);
    border-radius: 8px;
    font-weight: 400;
    font-size: var(--font-size-md);
    color: var(--tertiary-color);
  }
`;

export const ActivityButton = styled(ButtonComponent)`
  width: ${({ $width }) => ($width ? $width : "290px")};
  background: var(--tertiary-color);
  border: none;
  @media screen and (max-width: 768px) {
    font-size: var(--font-size-md);
    ${({ $smallButton }) =>
      $smallButton &&
      `width: 130px;
    height: 38px;
    font-weight: 500;
    font-size: var(--font-size-sm);`};
  }
`;
export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .ck.ck-editor {
    height: 100%;
    width: 100%;
    border: 1px solid var(--blue-color-dark);
    border-radius: 12px;
  }
  .ck.ck-editor__main > .ck-editor__editable {
    margin-top: 1.7rem;
    min-height: 110px;
    background: var(--button-color-labs);
    padding: 10px 10px !important;
    border-radius: 0px 0px 12px 12px;
    border: none;
    overflow-y: auto;
    &:focus {
      box-shadow: none;
    }
    @media screen and (max-width: 768px) {
      min-height: 155px;
    }
    p {
      margin-top: 5px;
      margin-bottom: 0px;
      @media screen and (max-width: 576px) {
        font-size: var(--font-size-xs);
      }
    }
  }
  .ck.ck-editor__top .ck-sticky-panel .ck-toolbar {
    border-radius: 12px 12px 0px 0px;
    background: var(--light-color);
  }
  label {
    z-index: 1;
    transform: translate(-11px, 72px);
    font-weight: 500;
    font-size: var(--font-size-sm);
    color: var(--tertiary-color);
    @media screen and (max-width: 576px) {
      font-size: var(--font-size-xs);
    }
  }
`;

export const StyledReportSection = styled.section`
  min-height: 150px;
  @media screen and (max-width: 768px) {
    min-height: 196px;
  }
`;

export const StyledUploadNewImage = styled.div`
  position: relative;
  width: 110px;
  height: 110px;
  border: 1.5px dashed var(--text-color-dark);
  border-radius: 8px;
  .gallery-add {
    cursor: pointer;
    position: absolute;
    top: 35%;
    left: 30%;
  }
  label {
    cursor: pointer;
    position: relative;
    top: -74px;
    left: 14px;
    width: 110px;
    height: 110px;
  }
  input {
    width: 110px;
    height: 110px;
  }
`;

export const StyledImageSection = styled.div`
  ${({ $displayGrid }) => $displayGrid && "display: grid;width: 100%"};
  grid-template-columns: repeat(auto-fill, 110px);
  gap: 12px;
  @media screen and (max-width: 576px) {
    justify-content: center;
  }
`;

export const UploadedImageWrapper = styled.div`
  position: relative;
  width: 110px;
  height: 110px;
  border-radius: 8px;
  border: 1px solid var(--text-color-dark);
  .close-square {
    position: absolute;
    cursor: pointer;
    top: 6px;
    right: 6px;
  }
  .uploaded-image {
    border-radius: 8px;
    object-fit: cover;
    object-position: center center;
  }
`;

export const StyledParagraph = styled.p`
  font-weight: 300;
  font-size: var(--font-size-xs);
  color: var(--text-color-muted);
`;

export const SkeletonWrapper = styled.section`
  display: grid;
  gap: 1rem;
  grid-template-columns: auto;
  grid-template-rows: [row1-start] 120px [row1-end] 120px [third-line] 130px [last-line];
  .skeleton {
    border-radius: 12px;
    border: 1px solid var(--blue-color-dark);
    min-height: 200px;
    width: 100%;
  }
`;
export const UploadImageSkeleton = styled(Skeleton)`
  align-self: start;
  min-height: 177px;
  width: 110px;
  border: 1.5px dashed var(--text-color-dark);
  border-radius: 8px;
`;
